<template>
  <sc-page-base
    title="Logs de Reversa - Erros de solicitação ">
    <sc-grid
      :data="logsReverse"
      :total="logsReverse.length"
      :loading="loading"
      @submit="getlogsReverse"
      :rules="rules"
      default-sort-column=“started”
      default-sort-direction=“desc”
      :default-filters="defaultFilters"
      :has-backend-sorting="false"
      :tableAttrs="{
        sorting: true
      }"
    >
      <template 
        slot="filters" 
        slot-scope="{ filters }">
        <sc-logs-reverse-filters 
          :filters="filters" 
          :rules="rules"/>
      </template>

      <template 
        slot="filters-actions" 
        slot-scope="{ isLoading }">
        
        <sc-button
          type="submit"
          theme="primary"
          text="Buscar"
          :loading="isLoading" />
      </template>
      
      <template 
        slot="table-columns" 
        slot-scope="{ props }">
        <sc-table-column
          label="Status"
          field="status"
          sortable>
            {{ props.row.status }}
        </sc-table-column>

        <sc-table-column
          label="Date e hora"
          field="started"
          sortable>
            {{ props.row.started | date('DD/MM/YYYY HH:mm:ss') }}
        </sc-table-column>

        <sc-table-column
          label="Data ultima atualização"
          field="modified"
          sortable>
            {{ props.row.modified | date('DD/MM/YYYY HH:mm:ss') }}
        </sc-table-column>

        <sc-table-column
          label="Transportadora"
          field="logistic_provider_name"
          sortable>
            {{ props.row.logistic_provider.name }}
        </sc-table-column>

        <sc-table-column
          label="Valores/Mensagens"
          field="message">
            {{ props.row.message }}
        </sc-table-column>

        <sc-table-column
          label="Quantidade de retentativas"
          field="retry_times"
          sortable>
            {{ props.row.retry_times }}
        </sc-table-column>

      </template>
    </sc-grid>
  </sc-page-base>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex';
  import {
    Moment,
  } from '@intelipost-js/secure-providers';
  import {
    ScPageBase,
    ScGrid,
    ScTableColumn,
    ScField,
    ScButton,
    ScInput,
    ScToast,
  } from '@intelipost-js/secure-components';
  import ScLogsReverseFilters from './components/sc-logs-reverse-filters/ScLogsReverseFilters';

  const {
    mapState,
    mapActions,
  } = createNamespacedHelpers('analytic/logsReverse');
  
  export default {
    name: 'page-logs-reverse',
    data() {
      return {
        defaultFilters: {
          dateRange: {
            start: Moment().subtract(6, 'days').format('YYYY-MM-DD'),
            end: Moment().format('YYYY-MM-DD'),
          },
          status: null,
          logistic_provider_id: null,
        },
        filterLogs: {},
        logsList: [],
        rules: {
          dateRange: [{
            required: true,
            message: 'Preencha o período com no máximo <strong>31 dias</strong>',
            validator: (rule, value, callback) => {
              const {
                start,
                end,
              } = value || {};
              const begin = Moment(start, 'YYYY-MM-DD');
              const finish = Moment(end, 'YYYY-MM-DD');
              const diff = Moment.duration(begin.diff(finish)).asDays() * -1;

              if (diff > 31 || !value) {
                callback(new Error());
              }
              callback();
            },
          }],
        },
      };
    },
    computed: {
      ...mapState([
        'loading',
        'logsReverse',
      ]),
    },
    methods: {
      ...mapActions([
        'getlogsReverse',
      ]),
    },
    components: {
      ScPageBase,
      ScGrid,
      ScTableColumn,
      ScField,
      ScButton,
      ScInput,
      ScLogsReverseFilters,
      ScToast,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/logs/pages/reverse/PageLogsReverse.vue?70e9cdd2